import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';

// Prev/next week arrows, the current range label ("Jun 22 – 28, 2026"), and a
// one-click "Today" jump. Pure presentational — state lives in useWeekNav.

type Props = {
  rangeLabel: string;
  onPrev: () => void;
  onNext: () => void;
  onToday: () => void;
};

const WeekNav = ({ rangeLabel, onPrev, onNext, onToday }: Props) => (
  <div className="dashv2-weeknav">
    <div className="dashv2-nav-group">
      <button
        type="button"
        className="dashv2-iconbtn"
        aria-label="Previous week"
        onClick={onPrev}
      >
        <ChevronLeftIcon />
      </button>
      <span className="dashv2-range">{rangeLabel}</span>
      <button
        type="button"
        className="dashv2-iconbtn"
        aria-label="Next week"
        onClick={onNext}
      >
        <ChevronRightIcon />
      </button>
    </div>
    <button type="button" className="dashv2-today-btn" onClick={onToday}>
      Today
    </button>
  </div>
);

export default WeekNav;
